<admin-header [primaryButtons]="headerPrimaryButtons" [title]="title" (eventFired)="headerButtonClick($event)"></admin-header>
<div class="cad-page">
	<div class="cad-page-toolbar" *ngIf="hasFile">
		<span class="cad-file-name">{{ fileName }}</span>
		<dx-button text="Clear" type="normal" icon="fal fa-times" (onClick)="clear()" class="ms-2"></dx-button>
		<span class="cad-page-hint text-muted ms-3 small">File stays in your browser — nothing is uploaded.</span>
	</div>
	<div class="cad-page-viewer">
		<cad-viewer [embedded]="true" (compareFileRequested)="onCompareRequested()"></cad-viewer>
		<div *ngIf="!hasFile" class="cad-page-empty text-muted">
			<i class="fal fa-cube fa-3x mb-2"></i>
			<div>Click "Open File" to load a .stp or .step model.</div>
		</div>
	</div>
</div>

<dx-popup [width]="500" [height]="'auto'" [showTitle]="true" title="Select CAD File" [dragEnabled]="false" [closeOnOutsideClick]="false" [showCloseButton]="true" container=".dx-viewport" [(visible)]="pickerVisible">
	<div *dxTemplate="let data of 'content'">
		<p class="text-muted small mb-3">Choose a .stp or .step file. It stays in your browser — nothing is uploaded.</p>
		<dx-file-uploader
			[multiple]="false"
			accept=".stp,.step"
			uploadMode="useForm"
			[showFileList]="false"
			[allowedFileExtensions]="['.stp', '.step']"
			selectButtonText="Choose CAD File"
			labelText="or drop a file here"
			(onValueChanged)="onFileSelected($event)"
		></dx-file-uploader>
	</div>
</dx-popup>

<dx-popup [width]="500" [height]="'auto'" [showTitle]="true" title="Choose File to Compare" [dragEnabled]="false" [closeOnOutsideClick]="false" [showCloseButton]="true" container=".dx-viewport" [(visible)]="comparePickerVisible">
	<div *dxTemplate="let data of 'content'">
		<p class="text-muted small mb-3">The original file stays in blue. The compare file will load in orange, semi-transparent, so you can see where they differ.</p>
		<dx-file-uploader
			[multiple]="false"
			accept=".stp,.step"
			uploadMode="useForm"
			[showFileList]="false"
			[allowedFileExtensions]="['.stp', '.step']"
			selectButtonText="Choose Compare File"
			labelText="or drop a file here"
			(onValueChanged)="onCompareFileSelected($event)"
		></dx-file-uploader>
	</div>
</dx-popup>
